import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { GetUserInfo } from "../../../utils/permissionChecker";
import { updateBranch } from "../../../services/employeeApi";
import { toast } from "react-toastify";
const UpdateBranch = ({ parentID, onSubmitButton }) => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };
  const [formData, setFormData] = useState({
    id: parentID.id,
    name: parentID.name,
    location: parentID.location,
    phone: parentID.phone,
    opening_date: formatDate(parentID.opening_date),
    status: 1,
    updated_by: currentUser,
  });
  const queryClient = useQueryClient();
  const UpdateBranchMutation = useMutation(async (data) => {
    await updateBranch(data);
    queryClient.invalidateQueries("branch");
  });
  const UpdateBranchData = async (Data) => {
    try {
      setIsSubmitting(true);
      await UpdateBranchMutation.mutateAsync(Data);
      toast.success("Branch is registerd successfully", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["name", "phone", "location"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    UpdateBranchData(formData);
  };
  const handleCloseModal = () => {
    onSubmitButton();
  };
  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  return (
    <>
      <Form onSubmit={handleSubmit}>
        {formerror ? (
          <Alert variant="danger">
            <p>Please tray again all fields are required.</p>{" "}
          </Alert>
        ) : (
          ""
        )}
        <Form.Group>
          <Form.Label className="text-secondary">Branch name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter branch name"
            value={formData.name}
            onChange={(e) => handleInputChange(e, "name")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="text-secondary">Branch location</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter branch location"
            value={formData.location}
            onChange={(e) => handleInputChange(e, "location")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="text-secondary">Branch phone</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter branch phone"
            value={formData.phone}
            onChange={(e) => handleInputChange(e, "phone")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="text-secondary">
            Branch opening date
          </Form.Label>
          <Form.Control
            type="date"
            placeholder="Enter branch opening date"
            value={formData.opening_date}
            onChange={(e) => handleInputChange(e, "opening_date")}
          />
        </Form.Group>
        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="btn btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="btn btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("update")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};
export default UpdateBranch;
